/**
 * @generated SignedSource<<2a2719b06b772a86d2f72a0ba1dcd5c8>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ExternalProjectBulkImportSubscription$variables = {
  integrationId: number;
};
export type ExternalProjectBulkImportSubscription$data = {
  readonly integration_by_pk: {
    readonly " $fragmentSpreads": FragmentRefs<"ExternalProjectBulkImport_integration">;
  } | null | undefined;
};
export type ExternalProjectBulkImportSubscription = {
  response: ExternalProjectBulkImportSubscription$data;
  variables: ExternalProjectBulkImportSubscription$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "integrationId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "integrationId"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "state",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ExternalProjectBulkImportSubscription",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "integration",
        "kind": "LinkedField",
        "name": "integration_by_pk",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "ExternalProjectBulkImport_integration"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "subscription_root",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ExternalProjectBulkImportSubscription",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "integration",
        "kind": "LinkedField",
        "name": "integration_by_pk",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "active",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "last_sync_at",
            "storageKey": null
          },
          {
            "alias": null,
            "args": [
              {
                "kind": "Literal",
                "name": "limit",
                "value": 1
              },
              {
                "kind": "Literal",
                "name": "order_by",
                "value": {
                  "id": "desc"
                }
              }
            ],
            "concreteType": "integration_sync",
            "kind": "LinkedField",
            "name": "integration_syncs",
            "plural": true,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "started_at",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "finished_at",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "info_messages",
                "storageKey": null
              }
            ],
            "storageKey": "integration_syncs(limit:1,order_by:{\"id\":\"desc\"})"
          },
          {
            "alias": null,
            "args": [
              {
                "kind": "Literal",
                "name": "order_by",
                "value": {
                  "id": "asc",
                  "name": "asc"
                }
              },
              {
                "kind": "Literal",
                "name": "where",
                "value": {
                  "active": {
                    "_eq": true
                  },
                  "sync": {
                    "_eq": false
                  }
                }
              }
            ],
            "concreteType": "ext_project",
            "kind": "LinkedField",
            "name": "ext_projects",
            "plural": true,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "name",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "sync",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "remote_id",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "remote_key",
                "storageKey": null
              }
            ],
            "storageKey": "ext_projects(order_by:{\"id\":\"asc\",\"name\":\"asc\"},where:{\"active\":{\"_eq\":true},\"sync\":{\"_eq\":false}})"
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "070e2c8e4f8b0b09b0559c3abbefc595",
    "id": null,
    "metadata": {},
    "name": "ExternalProjectBulkImportSubscription",
    "operationKind": "subscription",
    "text": "subscription ExternalProjectBulkImportSubscription(\n  $integrationId: Int!\n) {\n  integration_by_pk(id: $integrationId) {\n    ...ExternalProjectBulkImport_integration\n  }\n}\n\nfragment ExternalProjectBulkImport_integration on integration {\n  id\n  state\n  active\n  last_sync_at\n  integration_syncs(order_by: {id: desc}, limit: 1) {\n    id\n    state\n    started_at\n    finished_at\n    info_messages\n  }\n  ext_projects(where: {active: {_eq: true}, sync: {_eq: false}}, order_by: {name: asc, id: asc}) {\n    id\n    ...IntegrationImportProjectsTable_ext_project\n  }\n  ...IntegrationSyncDescription_integration\n}\n\nfragment IntegrationImportProjectsTable_ext_project on ext_project {\n  id\n  name\n  sync\n  remote_id\n  remote_key\n}\n\nfragment IntegrationSyncDescription_integration on integration {\n  id\n  ...IntegrationSyncStatus_integration\n}\n\nfragment IntegrationSyncStatus_integration on integration {\n  state\n  active\n  last_sync_at\n  integration_syncs(order_by: {id: desc}, limit: 1) {\n    id\n    state\n    started_at\n    finished_at\n    info_messages\n  }\n}\n"
  }
};
})();

(node as any).hash = "5c7a92ccf7f2f8abfa35aef68f86a272";

export default node;
